export const preApprovalStatusCodeMap = {
    'APPROVED': 2,
    'DENIED': 3,
}
